import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import * as React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'space-evenly',
    },
  },
}));

interface ListProps {
  ['aria-label']: string;
  className?: string;
}

export const List: React.FC<ListProps> = ({
  'aria-label': ariaLabel,
  className,
  children,
  ...rootProps
}) => {
  const classes = useStyles({});
  return (
    <Box
      aria-label={ariaLabel}
      className={clsx(classes.root, className)}
      role="tablist"
      align="center"
      {...rootProps}
    >
      {children}
    </Box>
  );
};
